// removed by extract-text-webpack-plugin
module.exports = {"container":"_3wtNGgOs8Kd9DTTzxJGp5Y"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Exchange/Layout/Navbar/styles.css
// module id = 1566
// module chunks = 83